var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateDetails',{attrs:{"get-function":() => {},"data":{}}},[_c('PageBack'),_c('Form',{ref:"form",attrs:{"title":_vm.$t('wallet_transaction.add'),"model":_vm.model,"fields":_vm.fields,"action":_vm.addWalletTransaction,"successMsg":_vm.$t('wallet.add_success'),"init-on-success":true},on:{"success":_vm.onSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }